module.exports = __webpack_public_path__ + "img/monospace.5c3e878f.svg";